import { f as flatMap_1 } from './flatMap-db621f8c.js';
import { as as myProductsGroupType, m as myProductsResponseStatus } from './currency-49e0d692.js';
import { B as getArray, C as isDefined } from './helpers-cd261aee.js';

const MAX_PRODUCT_DELTA_QTY = 99999;
function normalizeQuantity(quantity) {
  if (!quantity) {
    return 1;
  }
  if (quantity > MAX_PRODUCT_DELTA_QTY) {
    return MAX_PRODUCT_DELTA_QTY;
  }
  return quantity;
}
const productsParamsToPostData = (productsParams) => {
  var _a;
  const { id, quantity, creationDate, replacingQty, groupId, groupType, displayName, parentId } = productsParams;
  const productIds = getArray(id);
  const quantityList = getArray(quantity).map(normalizeQuantity);
  const creationDateList = getArray(creationDate);
  if (groupType) {
    return {
      products: productIds.map((id, index) => {
        var _a;
        return (Object.assign({ productId: id, quantity: (_a = quantityList[index]) !== null && _a !== void 0 ? _a : 1 }, (isDefined(creationDateList[index]) && { creationDate: creationDateList[index] })));
      }),
      options: {
        allowPartialAdding: false,
        source: groupType,
      },
      grouping: {
        displayName: displayName || '',
        configurationMasterId: groupId || '',
        enable: true,
        quantity: 1,
        backURL: '',
      },
    };
  }
  const qty = (_a = quantityList[0]) !== null && _a !== void 0 ? _a : 1;
  const product = Object.assign(Object.assign({ productId: productIds[0], quantity: qty }, (isDefined(creationDate) && { creationDate })), (parentId && {
    obsoleteProductId: parentId,
    replacingQty: isDefined(replacingQty) ? replacingQty : qty,
  }));
  return {
    products: [product],
    options: { allowPartialAdding: false },
  };
};
const getSingleProductList = (productsGroups) => {
  if (!productsGroups)
    return [];
  const wishLists = productsGroups.filter((productsGroup) => productsGroup.type === myProductsGroupType.SINGLE);
  return flatMap_1(wishLists, (group) => group.products);
};
const isProductUpdated = (productId, response) => {
  var _a;
  return response &&
    'productsUpdated' in response &&
    Boolean((_a = response.productsUpdated) === null || _a === void 0 ? void 0 : _a.find((id) => id === productId));
};
const isSingleProductInListFinally = (productId, response) => {
  if ((response === null || response === void 0 ? void 0 : response.status) !== myProductsResponseStatus.SUCCESS) {
    return null;
  }
  return isProductUpdated(productId, response);
};
const isProductsInMyProductsGroups = (products, myProductsGroups, options) => {
  return myProductsGroups.some((myProductsGroup) => {
    const productsIds = Object.keys(products);
    const productsCount = productsIds.length;
    const myProductsGroupHashmap = myProductsGroup.products.reduce((result, product) => {
      result[product.productId] = product.quantity;
      return result;
    }, {});
    const myProductsCount = Object.keys(myProductsGroupHashmap).length;
    if (options.isGroup && myProductsCount !== productsCount) {
      return false;
    }
    return productsIds.every((id) => {
      if (id in myProductsGroupHashmap) {
        if (options.isGroup) {
          return myProductsGroupHashmap[id] === products[id];
        }
        return myProductsGroupHashmap[id] >= products[id];
      }
      return false;
    });
  });
};
const isProductInMyProducts = (product, myProductsGroups) => {
  const groups = myProductsGroups.filter((myProductsGroup) => myProductsGroup.type === myProductsGroupType.SINGLE);
  return isProductsInMyProductsGroups(product, groups, { isGroup: false });
};
const isProductGroupInMyProducts = (products, myProductsGroups) => {
  const groups = myProductsGroups === null || myProductsGroups === void 0 ? void 0 : myProductsGroups.filter((myProductsGroup) => myProductsGroup.type === myProductsGroupType.GROUP);
  return isProductsInMyProductsGroups(products, groups, { isGroup: true });
};

export { isProductUpdated as a, isSingleProductInListFinally as b, isProductGroupInMyProducts as c, getSingleProductList as g, isProductInMyProducts as i, productsParamsToPostData as p };
